import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
export const updateUserPassword = async (email, newPassword) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/Coltec/UpdateUserPassword`,
      { email, newPassword }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating password:", error);
    throw error;
  }
};
